import React from 'react';
import CheckoutBox from '../components/CheckoutBox';
import { Image as DatoImage } from 'react-datocms';
import StripeCheckout from "@/components/StripeCheckout/StripeCheckout";
import { PayPalButtons } from "@paypal/react-paypal-js";
import { CheckoutPurchaseStarted, CheckoutStarted } from "@/analytics/events";
import { BlockKlaviyo, useAnalytics } from '@/analytics/AnalyticsProvider';
import { useRouter } from 'next/router';
import { useSearchParams } from 'next/navigation';

export const CheckoutScreen3 = ({ sessionId, token, email, isLoading, setLoading, showPlanButtons = true, selectedParentPlan }) => {
    const analytics = useAnalytics();

    // get the account id
    const params = useSearchParams();
    console.log('params', params);
    // const accountId = useSearchParam('a');
    const accountId = null;

    const settings = {
        'style': {
            shape: 'rect',
            color: 'blue',
            layout: 'vertical',
            label: 'subscribe'
        },
        createSubscription(data, actions) {
            return actions.subscription.create({
                /* Creates the subscription */
                // eslint-disable-next-line camelcase
                plan_id: 'P-9DF54239CV138362BMWS3QXQ'
            });
        },
        onApprove(data, actions) {
            alert(data.subscriptionID); // You can add optional success message for the subscriber here
        }
    };

    React.useEffect(() => {
        analytics.track(CheckoutPurchaseStarted, { sessionId, token, email }, BlockKlaviyo);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    return (
        <div className='flex flex-col gap-4 text-black '>
            {/*
               <div id='paypal-button-container-P-9DF54239CV138362BMWS3QXQ'></div>
            <script src='https://www.paypal.com/sdk/js?client-id=AdOyIL03JtPTx2nk-NW4MJQf-EPmkiyu3aY-bJY6-NhV_7LpzEkRNsFBnS6C0XKkadDek8YUphiZzEHm&vault=true&intent=subscription' data-sdk-integration-source='button-factory'>
            </script>
            <script>
                paypal.Buttons(settings).render('#paypal-button-container-P-9DF54239CV138362BMWS3QXQ'); // Renders the PayPal button
            </script>*/}


            <StripeCheckout
                id='stripe-checkout'
                sessionId={sessionId}
                accountId={accountId}
                token={token}
                initialEmail={email}
                showPlanButtons={showPlanButtons}
                selectedParentPlan={selectedParentPlan}
                teacher={false}
                timesTables={false}
                // setLoading={setLoading}
                // isLoading={isLoading}
            />

        </div>
    );
};
